import { createReducer, on } from '@ngrx/store';

import { initialCoreDataState } from './core-data.state';
import {
  resetCountries,
  resetCurrencies,
  resetSalutations,
  setCountries,
  setCurrencies,
  setSalutations,
} from './core-data.actions';

import { Utility } from 'src/services/utility.service';

import { Countries } from 'src/models/Countries';
import { Currencies } from 'src/models/Currencies';
import { Salutations } from 'src/models/Salutations';

export const coreDataReducer = createReducer(
  initialCoreDataState,

  on(setCountries, (state, action) => {
    const countries: Countries = action.countries;
    Utility.setStore('countries', countries, true);

    return {
      ...state,
      countries,
    };
  }),

  on(resetCountries, (state) => {
    Utility.removeStore('countries');

    return {
      ...state,
      countries: undefined,
    };
  }),

  on(setCurrencies, (state, action) => {
    const currencies: Currencies = action.currencies;
    Utility.setStore('currencies', currencies, true);

    return {
      ...state,
      currencies,
    };
  }),

  on(resetCurrencies, (state) => {
    Utility.removeStore('currencies');

    return {
      ...state,
      currencies: undefined,
    };
  }),

  on(setSalutations, (state, action) => {
    const salutations: Salutations = action.salutations;
    Utility.setStore('salutations', salutations, true);

    return {
      ...state,
      salutations,
    };
  }),

  on(resetSalutations, (state) => {
    Utility.removeStore('salutations');

    return {
      ...state,
      salutations: undefined,
    };
  })
);
